var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require('react');
var createReactClass = require('create-react-class');
var ReactDOM = require('react-dom');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var utils = require('../../../../utils/utils');
var dashboardUtils = require('../../utils');
var LineChart = require('./lineChart.jsx');

var NavListItem = createReactClass({
    mixins: [PureRenderMixin],

    componentDidMount: function(){
        var activeColor = dashboardUtils.getColorFromDashboardGradientBasedOnPercentile(this.getPercentile());
        var $componentEle = $(ReactDOM.findDOMNode(this));
        $componentEle.css('border-left-color', activeColor);
        $componentEle.find('.item-severity-level').css('color', activeColor);
    },

    handleClick: function(){
        if(this.props.isActive){
            this.props.removeActiveItem(this.props.scoreItem.item);
        }else{
            this.props.addActiveItem(this.props.scoreItem.item);
        }
        this.props.clickTracking('Click', this.props.scoreItem.item.displayName);
    },

    getClassName: function(){
        var className = 'nav-list-item';
        if(this.props.isHighlight){
            className += ' is-highlight';
        }
        if(this.props.isActive){
            className += ' is-active';
        }
        return className;
    },

    getPercentile: function(){
        var itemScoresData = this.props.id2ItemScoresData[this.props.scoreItem.item.id];
        return this.props.scoreItem.percentile || itemScoresData.scores[itemScoresData.scores.length - 1].percentile;
    },

    render: function(){
        var percentile = this.getPercentile();
        var severityLevel = dashboardUtils.getSeverityLevel(percentile);

        return (
            <li id={this.props.id} className={this.getClassName()} onClick={this.handleClick}>
                <p className="item-name" title={this.props.scoreItem.item.displayName}><span className="text">{this.props.scoreItem.item.displayName}</span>{severityLevel === 'extreme' ? <span className="ion-alert-circled"></span> : null}</p>
                <p className="item-severity-level">{severityLevel}</p>
                <p className="item-severe-percentile show-for-medium">{percentile}</p>
                {utils.isSmallScreen() &&
                    <div className="trend-chart show-for-small-only">
                        <LineChart isTrend={true} itemScoresDataList={[this.props.id2ItemScoresData[this.props.scoreItem.item.id]]}></LineChart>
                    </div>
                }
            </li>
        )
    }
});

module.exports = NavListItem;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/navListItem.jsx